var $0a21593b698c8a7d$exports = {};
$0a21593b698c8a7d$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$0a21593b698c8a7d$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
